/**
 * @repo/ui - 统一导出入口
 * @description 导出所有共享 UI 组件和类型
 */

// ==================== Header ====================
// Header is server-only and must be imported from the dedicated entrypoint.
// Client components should use `import Header from "@repo/ui/header"`.

// ==================== Footer ====================
export { default as Footer } from "./components/Footer"

// ==================== SignIn ====================
export { ForgotPassword, Login, Register } from "./components/SignIn"
export type { SignInType } from "./components/SignIn"

// ==================== IconFont ====================
export { default as IconFont } from "./components/IconFont"

// ==================== Utils ====================
export { default as usePreventScrollPenetration } from "./utils/hooks"
export { default as http } from "./utils/http"

// ==================== SharePoster ====================
export { default as SharePoster } from "./components/SharePoster"

// ==================== PageTracker ====================
export { default as PageTracker } from "./components/PageTracker"

// ==================== ErrorDisplay ====================
export { default as ErrorDisplay } from "./components/ErrorDisplay"

// ==================== CookieConsent ====================
export { default as CookieConsent } from "./components/CookieConsent"
// ==================== MetrixDrawerEntry ====================
export { default as MetrixDrawerEntry } from "./components/MetrixDrawerEntry"
// ==================== UnionIconAffix ====================
export { default as UnionIconAffix } from "./components/UnionIconAffix"
export type { UnionIconAffixProps } from "./components/UnionIconAffix"

// ==================== AdComponent ====================
export { AdComponent, PosTypeEnum } from "./components/AdComponent"
export type { AdComponentProps, AdComponentTypes, AdListType, AdvertsType } from "./components/AdComponent"

// ==================== EllipsisTooltip ====================
export { default as EllipsisTooltip, useIsOverflow } from "./components/EllipsisTooltip"
export type { EllipsisTooltipProps } from "./components/EllipsisTooltip"

// ==================== NotFound ====================
export { default as NotFound } from "./components/NotFound"
